import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, ChangeDetectionStrategy, Directive, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';

const _c0$2 = ["*", [["xpo-card-action"]]];
const _c1$2 = ["*", "xpo-card-action"];
class XpoCardFooter {
}
XpoCardFooter.ɵfac = function XpoCardFooter_Factory(t) { return new (t || XpoCardFooter)(); };
XpoCardFooter.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoCardFooter, selectors: [["xpo-card-footer"]], hostAttrs: [1, "xpo-Card-footer"], ngContentSelectors: _c1$2, decls: 2, vars: 0, template: function XpoCardFooter_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c0$2);
        i0.ɵɵprojection(0);
        i0.ɵɵprojection(1, 1);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoCardFooter, [{
        type: Component,
        args: [{
                selector: 'xpo-card-footer',
                templateUrl: 'card-footer.component.html',
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                host: { class: 'xpo-Card-footer' },
            }]
    }], null, null); })();

const _c0$1 = [[["xpo-card-title"]], [["xpo-card-actions"]]];
const _c1$1 = ["xpo-card-title", "xpo-card-actions"];
class XpoCardHeaderShadow {
}
XpoCardHeaderShadow.ɵfac = function XpoCardHeaderShadow_Factory(t) { return new (t || XpoCardHeaderShadow)(); };
XpoCardHeaderShadow.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoCardHeaderShadow, selectors: [["", "xpo-card-header-shadow", ""], ["", "xpoCardHeaderShadow", ""]], hostAttrs: [1, "xpo-Card--headerShadow"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoCardHeaderShadow, [{
        type: Directive,
        args: [{
                selector: '[xpo-card-header-shadow], [xpoCardHeaderShadow]',
                host: {
                    class: 'xpo-Card--headerShadow',
                },
            }]
    }], null, null); })();
class XpoCardTitle {
}
XpoCardTitle.ɵfac = function XpoCardTitle_Factory(t) { return new (t || XpoCardTitle)(); };
XpoCardTitle.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoCardTitle, selectors: [["xpo-card-title"]], hostAttrs: [1, "xpo-Card-title"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoCardTitle, [{
        type: Directive,
        args: [{
                selector: 'xpo-card-title',
                host: { class: 'xpo-Card-title' },
            }]
    }], null, null); })();
class XpoCardHeader {
}
XpoCardHeader.ɵfac = function XpoCardHeader_Factory(t) { return new (t || XpoCardHeader)(); };
XpoCardHeader.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoCardHeader, selectors: [["xpo-card-header"]], hostAttrs: [1, "xpo-Card-header"], ngContentSelectors: _c1$1, decls: 2, vars: 0, template: function XpoCardHeader_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c0$1);
        i0.ɵɵprojection(0);
        i0.ɵɵprojection(1, 1);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoCardHeader, [{
        type: Component,
        args: [{
                selector: 'xpo-card-header',
                templateUrl: './card-header.component.html',
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                host: { class: 'xpo-Card-header' },
            }]
    }], null, null); })();

const _c0 = [[["xpo-card-header"]], "*", [["xpo-card-footer"]]];
const _c1 = ["xpo-card-header", "*", "xpo-card-footer"];
class XpoCardActions {
}
XpoCardActions.ɵfac = function XpoCardActions_Factory(t) { return new (t || XpoCardActions)(); };
XpoCardActions.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoCardActions, selectors: [["xpo-card-actions"]], hostAttrs: [1, "xpo-Card-actions"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoCardActions, [{
        type: Directive,
        args: [{
                selector: 'xpo-card-actions',
                host: { class: 'xpo-Card-actions' },
            }]
    }], null, null); })();
class XpoCardContent {
}
XpoCardContent.ɵfac = function XpoCardContent_Factory(t) { return new (t || XpoCardContent)(); };
XpoCardContent.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoCardContent, selectors: [["xpo-card-content"]], hostAttrs: [1, "xpo-Card-content"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoCardContent, [{
        type: Directive,
        args: [{
                selector: 'xpo-card-content',
                host: { class: 'xpo-Card-content' },
            }]
    }], null, null); })();
class XpoCard {
    constructor() {
        this.status = null;
        this.type = 'basic';
        this.color = 'primary';
    }
}
XpoCard.ɵfac = function XpoCard_Factory(t) { return new (t || XpoCard)(); };
XpoCard.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoCard, selectors: [["xpo-card"]], hostAttrs: [1, "xpo-Card"], hostVars: 16, hostBindings: function XpoCard_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵclassProp("xpo-Card--success", ctx.status === "success")("xpo-Card--warn", ctx.status === "warn" || ctx.color === "warn")("xpo-Card--error", ctx.status === "error")("xpo-Card--noStatus", !ctx.status)("xpo-Card--basic", ctx.type === "basic")("xpo-Card--data", ctx.type === "data")("xpo-Card--primary", ctx.color === "primary")("xpo-Card--accent", ctx.color === "accent");
    } }, inputs: { status: "status", type: "type", color: "color" }, ngContentSelectors: _c1, decls: 5, vars: 0, consts: [[1, "xpo-Card-status"], [1, "xpo-Card-container"]], template: function XpoCard_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c0);
        i0.ɵɵelement(0, "div", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵelementStart(2, "div", 1);
        i0.ɵɵprojection(3, 1);
        i0.ɵɵelementEnd();
        i0.ɵɵprojection(4, 2);
    } }, styles: [".flex--stretch{flex:1}.xpo-Card{display:flex;flex-direction:column;width:100%}.xpo-Card-status{height:4px;width:100%}.xpo-Card--success .xpo-Card-status{background-color:#11a63b}.xpo-Card--error .xpo-Card-status{background-color:#d50000}.xpo-Card--warn .xpo-Card-status{background-color:#ffba00}.xpo-Card--noStatus>.xpo-Card-status{display:none}.xpo-Card--data.xpo-Card--primary .xpo-Card-header{color:#4a4a4a}.xpo-Card--data.xpo-Card--primary .xpo-Card-header .xpo-Card-title{color:#4a4a4a}.xpo-Card--data.xpo-Card--primary .xpo-Card-header{background-color:#d8d8d8}.xpo-Card--data.xpo-Card--accent .xpo-Card-header{color:#fff}.xpo-Card--data.xpo-Card--accent .xpo-Card-header .xpo-Card-title{color:#fff}.xpo-Card--data.xpo-Card--accent .xpo-Card-header{background-color:#4a4a4a}.xpo-Card--data.xpo-Card--warn .xpo-Card-header{color:#fff}.xpo-Card--data.xpo-Card--warn .xpo-Card-header .xpo-Card-title{color:#fff}.xpo-Card--data.xpo-Card--warn .xpo-Card-header{background-color:#ffba00}.xpo-Card-header,.xpo-Card-footer{align-items:center;display:flex;flex:0 0 auto;padding:8px}.xpo-Card-header{min-height:35px}.xpo-Card-header-toggleIcon{cursor:pointer;padding:8px}.xpo-Card-header-toggleIcon:after{border-style:solid;border-width:0 2px 2px 0;content:\"\";display:inline-block;margin-bottom:3px;padding:3px;transform:rotate(45deg)}.xpo-Card-footer{height:44px}.xpo-Card-title{font-size:1.143rem;font-weight:500;letter-spacing:.3px;line-height:1.143}.xpo-Card-actions{margin-left:auto}.xpo-Card-actions .mat-button,.xpo-Card-actions .mat-raised,.xpo-Card-actions .mat-stroked-button,.xpo-Card-actions .mat-flat-button,.xpo-Card-actions .mat-icon-button{margin-right:8px}.xpo-Card-actions .mat-button:last-child,.xpo-Card-actions .mat-raised:last-child,.xpo-Card-actions .mat-stroked-button:last-child,.xpo-Card-actions .mat-flat-button:last-child,.xpo-Card-actions .mat-icon-button:last-child{margin-right:0}.xpo-Card-container{overflow:hidden}.xpo-Card-content{display:block;overflow:auto;padding:10px}.xpo-Card--headerShadow .xpo-Card-header{box-shadow:0 2px 1px -1px #0003,0 1px 1px #00000024,0 1px 3px #0000001f}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoCard, [{
        type: Component,
        args: [{
                selector: 'xpo-card',
                templateUrl: './card.component.html',
                styleUrls: ['./card.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: {
                    class: 'xpo-Card',
                    '[class.xpo-Card--success]': 'status === "success"',
                    '[class.xpo-Card--warn]': 'status === "warn" || color === "warn"',
                    '[class.xpo-Card--error]': 'status === "error"',
                    '[class.xpo-Card--noStatus]': '!status',
                    '[class.xpo-Card--basic]': 'type === "basic"',
                    '[class.xpo-Card--data]': 'type === "data"',
                    '[class.xpo-Card--primary]': 'color === "primary"',
                    '[class.xpo-Card--accent]': 'color === "accent"',
                },
            }]
    }], null, { status: [{
            type: Input
        }], type: [{
            type: Input
        }], color: [{
            type: Input
        }] }); })();

class XpoCardModule {
}
XpoCardModule.ɵfac = function XpoCardModule_Factory(t) { return new (t || XpoCardModule)(); };
XpoCardModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoCardModule });
XpoCardModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, MatTooltipModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoCardModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, MatTooltipModule],
                declarations: [
                    XpoCard,
                    XpoCardActions,
                    XpoCardContent,
                    XpoCardFooter,
                    XpoCardHeader,
                    XpoCardTitle,
                    XpoCardHeaderShadow,
                ],
                exports: [XpoCard, XpoCardActions, XpoCardContent, XpoCardFooter, XpoCardHeader, XpoCardTitle, XpoCardHeaderShadow],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoCardModule, { declarations: [XpoCard,
        XpoCardActions,
        XpoCardContent,
        XpoCardFooter,
        XpoCardHeader,
        XpoCardTitle,
        XpoCardHeaderShadow], imports: [CommonModule, MatTooltipModule], exports: [XpoCard, XpoCardActions, XpoCardContent, XpoCardFooter, XpoCardHeader, XpoCardTitle, XpoCardHeaderShadow] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { XpoCard, XpoCardActions, XpoCardContent, XpoCardFooter, XpoCardHeader, XpoCardHeaderShadow, XpoCardModule, XpoCardTitle };
